import CookieConsentDialog from './CookieConsentDialog'
export default CookieConsentDialog
